"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var interfaces_1 = require("@hudled/interfaces");
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var IconButtons_1 = require("atomicComponents/molecules/IconButtons/IconButtons");
var hooks_1 = require("containers/Modals/CreateCustomerModal/hooks");
var Divider_1 = __importDefault(require("shared/components/Divider"));
var DropdownMenu_1 = __importDefault(require("shared/components/DropdownMenu"));
var DropdownOption_1 = __importDefault(require("shared/components/DropdownMenu/DropdownOption"));
var single_1 = require("utils/selectors/single");
var AccessDropdown = function (_a) {
    var item = _a.item;
    var myCompany = (0, react_redux_1.useSelector)(single_1.selectMyCompany);
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfile);
    var _b = __read(react_1.default.useState(null), 2), anchorEl = _b[0], setAnchorEl = _b[1];
    var handleClick = function (event) { return setAnchorEl(anchorEl ? null : event.currentTarget); };
    var _c = __read((0, hooks_1.useSwitchIntoCompany)(), 2), switchIntoCompany = _c[0], isSwitching = _c[1];
    var handleOnClose = function () { return setAnchorEl(null); };
    // const canAccessCompany = myCompany?.id !== item.id && (profile.isAdmin || profile.companyIds.includes(item.id));
    //
    // if (!canAccessCompany) {
    //   return <SlashedMenu mx={2.625} size="small" tooltipTitle="You cannot access this customer" />;
    // }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(IconButtons_1.ExpandMenuButton, { onClick: handleClick, sx: { mx: 2 } }), (0, jsx_runtime_1.jsxs)(DropdownMenu_1.default, __assign({ anchorEl: anchorEl, open: !!anchorEl, onClose: handleOnClose }, { children: [(0, jsx_runtime_1.jsx)(DropdownOption_1.default, { title: "Access account", titleColor: "green", disabled: isSwitching, onClick: function () { return switchIntoCompany(item.id, profile.isAdmin ? interfaces_1.ACCESS_LEVEL.Admin : undefined); }, autoFocus: (myCompany === null || myCompany === void 0 ? void 0 : myCompany.id) !== item.id }), (0, jsx_runtime_1.jsx)(Divider_1.default, {}), (0, jsx_runtime_1.jsx)(DropdownOption_1.default, { title: "Remove my access", description: "Your access will be revoked, an owner can reinvite you.", titleColor: "red", onClick: handleOnClose, autoFocus: (myCompany === null || myCompany === void 0 ? void 0 : myCompany.id) === item.id, disabled: true })] }))] }));
};
exports.default = AccessDropdown;
